<template>
  <div class="pa-4 text-center">
    <v-dialog 
      :model-value="props.cookiesdialog"
      @update:modelValue="val => emit('update:cookiesdialog', val)"
    >
       
      <template v-slot:default="{ isActive }">
        <v-card >
          <template v-slot:text>
             <v-card
                class="mx-auto"
                prepend-icon="mdi-shield-account"
                :subtitle="`viewing ${getcookiesval}`"
                v-if="getcookiesval === 'privacy_policy'"
              >
                <template v-slot:title>
                  <span class="font-weight-black">Privacy Policy</span>
                </template>

                <v-card-text class="bg-surface-light pt-4"  >
                  <div v-html=termOfService[0].nbprivacypolicy></div>
                </v-card-text>
              </v-card>

              <v-card
                class="mx-auto"
                prepend-icon="mdi-shield-account"
                :subtitle="`viewing ${getcookiesval}`"
                v-else-if="getcookiesval === 'cookies_policy'"
              >
                <template v-slot:title>
                  <span class="font-weight-black">Nexgbits Inc - Cookies Policy</span>
                </template>

                <v-card-text class="bg-surface-light pt-4">
                  <div v-html=termOfService[0].nbcookiespolicy></div>
                </v-card-text>
              </v-card>

              <v-card
                class="mx-auto"
                prepend-icon="mdi-shield-account"
                :subtitle="`viewing ${getcookiesval}`"
                v-else-if="getcookiesval === 'terms_of_use'"
              >
                <template v-slot:title>
                  <span class="font-weight-black">Nexgbits Inc - Terms of use</span>
                </template>

                <v-card-text class="bg-surface-light pt-4">
                  <div v-html=termOfService[0].nbtermofservice></div>
                </v-card-text>
              </v-card>

              <v-card
                class="mx-auto"
                prepend-icon="$vuetify"
                :subtitle="`viewing ${getcookiesval}`"
                v-else
              >
                <template v-slot:title>
                  <span class="font-weight-black">Welcome to Vuetify</span>
                </template>

                <v-card-text class="bg-surface-light pt-4">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi, ratione debitis quis est labore voluptatibus! Eaque cupiditate minima, at placeat totam, magni doloremque veniam neque porro libero rerum unde voluptatem!
                </v-card-text>
              </v-card>
          </template>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              text="Disagree"
              variant="text"
              @click="isActive.value = false; closeDialog"
            ></v-btn>

            <v-btn
              color="surface-variant"
              text="Agree"
              variant="flat"
              @click="isActive.value = false; closeDialog"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import axios from 'axios'
import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()
const getlang = ref('')

const props = defineProps({
  cookiesdialog: Boolean,
  getcookiesval: String
})

const emit = defineEmits(['update:cookiesdialog'])

const termOfService = ref([])

const closeDialog = () => {
  emit('update:cookiesdialog', false)
}

const getcookiesval = ref(props.getcookiesval)
watch(() => props.getcookiesval, (newVal) => {
  getcookiesval.value = newVal
})
console.log('title is' + getcookiesval.value)

onMounted(async () => {
  getlang.value = localStorage.getItem('locale')
  try {
    termOfService.value = (await axios.get('readonly-terms-of-service/')).data
    console.log("Terms of service")
    console.log(termOfService.value)
  } catch (err) {
    console.error('Error loading menus:', err)
  }
})
</script>